import { debounce } from 'lodash';

// The number of milliseconds to throttle invocations to
const DEBOUNCE_WAIT_TIME = 800;

(function () {
  angular
    .module('kareo.ui.shared.directives.user.k-user-list', [
      'kareo.ui.shared.directives.k-spinner',
      'kareo.ui.shared.directives.user.k-user-list-view',
      'kareo.ui.shared.directives.templates',
      'kareo.ui.shared.modules.api.user.k-user-service',
      'kareo.ui.shared.directives.user.k-user-list-empty'
    ])
    .component('kUserList', {
      bindings: {
        applyFilterFunction: '<?',
        onSelect: '&?',
        selectIconClass: '@?',
        selectText: '@?',
        pagination: '<?',
        pageSize: '<?',
        pageNumber: '<?',
        setTotalPages: '=?',
        filters: '<?',
        nonProviderUsers: '=?',
      },
      controller,
      controllerAs: 'vm',
      template: require('./k-user-list.pug')()
    });

    controller.$inject = ['$scope','$filter','$timeout', 'kUserService'];
    function controller($scope, $filter, $timeout, kUserService) {
      const vm = this;
      const debounceLoadUsers = debounce(loadUsers, DEBOUNCE_WAIT_TIME);

      vm.hasError = false;
      vm.isLoading = true;
      vm.users = [];
      vm.originalUsersList = [];
      vm.totalUserCount = 0;

      vm.selectUser = selectUser;

      vm.$onInit = init;

      $scope.$watchGroup(['vm.pageNumber','vm.filters.search','vm.pageSize','vm.pagination','vm.filters'], debounceLoadUsers);

      // ---------------------------------------------------------------------

      function init() {
        loadUsers();
      }

      function setTotalPages(totalCount){
        if(!!vm.setTotalPages && !isNaN(vm.pageSize) && !isNaN(totalCount)){
          vm.setTotalPages(Math.ceil(totalCount / vm.pageSize));
        }
      }

      function showSpiner(){
        vm.isLoading = true;
      }

      function loadUsers(){
        $timeout(showSpiner).then(()=>{
          requestUsers().then((response) => {
            const setUserDataIntoScope = () => {
              let items = !!response?.items ? response.items : [];
              vm.originalUsersList = items;
              items = maybeFilter(items);
              vm.users = addFullNames(items);
              setTotalPages(response?.totalCount)
              vm.totalUserCount = response?.totalCount;
              vm.isLoading = false;
            };
            if(vm.pagination){
              $scope.$apply(setUserDataIntoScope);
            } else {
              setUserDataIntoScope();
            }
          }).catch((err) => {
            $scope.$apply(function(){
              vm.hasError = true;
              vm.users = [];
              vm.isLoading = false;
            });
          });
        });
      }

      function requestUsers(){
        if(!!vm.pagination){
          return kUserService
            .getUsersForPracticePaged({pageSize: vm.pageSize, pageNumber: vm.pageNumber, filter: vm.filters});
            
        } else {
          return kUserService
            .getAllUsersForPractice()
            .then((users) => {
              return {items: !!users ? users : []};
            }, (error) => {
              return {items:[]};
            });
        }
      }

      function maybeFilter(users) {
        return !!vm.applyFilterFunction ?
              $filter('filter')(users, vm.applyFilterFunction) :
              users;
      }

      function getFullName(user) {
        let userFullName = '';
        if(!!user) {
          if(!!user.firstName) {
            userFullName += user.firstName+' ';
          }
          if(!!user.middleName) {
            userFullName += user.middleName+' ';
          }
          // The regular expression condition is used to validate texts like this "{1029-1}", because it is a temporal last name for the provider shells
          if(!!user.lastName && !user.lastName.match(/\{\d+-\d+\}/)) {
            userFullName += user.lastName;
          }
          userFullName = removeBrackets(userFullName);
        }
        return userFullName;
      }

      function removeBrackets(source) {
        if (!source || source.length === 0) return;
        const charList = source.split('');
        const result = charList.map(char => (char != '{' && char != '}' ? char : ''));
        return result.join('');
      }

      function addFullNames(users) {
        return users.map(user => {
          const fullName = getFullName(user);
          return {...user, fullName }; 
        });
      }
    
      function selectUser(user) {
        if (!!vm.onSelect) {
          if(!!vm.nonProviderUsers) {
            getNonProviderUsers(user.isProviderShell);
          }
          vm.onSelect({ user });
        }
      }

      function getNonProviderUsers(isProviderShell){
        if(!isProviderShell){
          vm.nonProviderUsers = [];
          return;
        }
        if(!vm.pagination || vm.totalUserCount === vm.originalUsersList.length) {
          vm.nonProviderUsers = vm.originalUsersList.filter(u => !u.isLocked && !u.isProvider);
          return;
        }
        const nonProviderfilters = {showLockedUsers: false, showUnLockedUsers: true, showProviders: false, showNonProviders: true};
        // The maximun of the page is 1000, we don't expect the total account of providers more than that, 
        // because this logic would apply only for new customers which are completing the user shells information
        kUserService
          .getUsersForPracticePaged({pageSize: vm.totalUserCount > 1000 ? 1000 : vm.totalUserCount, pageNumber: 0, filter: nonProviderfilters})
          .then(response => { vm.nonProviderUsers = response.items; });
      }
  }
})();
